
import request from '../request';
import qs from 'qs';

// 系统语言更改
const changLanguage = function (data) {
  return request.post(`/api/wx/changLanguage`, data)
}
// 获取会员信息
const showEmployeeInfo = (data) => {
  return request.post(`/api/wx/auth/showEmployeeInfo?${qs.stringify(data)}`, data)
}
// 有效保险卡
const queryEffectiveCard = (data) => {
  return request.post(`/api/wx/auth/queryEffectiveCard?${qs.stringify(data)}`, data)
}
// 获取UDESK在线客服URL
const getUdeskUrl = (data) => {
  return request.post('/api/wx/auth/getUdeskUrl', data)
}
// 获取公众号jssdk签名
const getJsJdkSign = (data) => {
  return request.post('/api/wx/getJsJdkSign', data)
}
const getWxShareSign = (data) => {
  return request.post('/api/visitor/wallet/getJsJdkSign', data)
}
// 
const getMemberInfoFile =  (memberNo) => {
  return request.get(`/api/wx/auth/getMemberInfoFile/${memberNo}`)
}
// 个人信息
const queryUserInfo = (data) => {
  return request.post('/api/wx/auth/personCenterInfo', data)
}
// 文件上传
const fileUpload = (data) => {
  return request.post('/api/visitor/upload', data)
}
const queryPCA = (data) => {
	return request.post('/api/wx/auth/memberInfo/getAreaInfo', data)
}
// 查询省数据
const getProviderListToWeb = (data) => {
  return request.post(`/api/wx/getProviderListToWeb?${qs.stringify(data)}`)
}
// 查询保单下的所有被保人
const queryPersonByPolicy = function (data) {
  return request.post(`/api/wx/auth/queryPersonByPolicy`, data)
}
// 材料查询
const getFileType = (data) => {
  return request.post('/api/wx/auth/calimApp/getFileType', data)
}
// 材料补充
const preAuthpatch = (data) => {
  return request.post(`/api/wx/auth/preLicensing/patch`, data)
}
// 医疗机构条件筛选
const getProviderList = (data) => {
  return request.post('/api/wx/auth/getProviderList', data)
}
// 默认不展示在线问诊的入口
const getIncrementRight = (data) => {
    return request.post('/api/visitor/getIncrementRight', data)
  }
// 对象数组
export default {
  changLanguage,
  showEmployeeInfo,
  queryEffectiveCard,
  getUdeskUrl,
  getJsJdkSign,
  getWxShareSign,
  getMemberInfoFile,
  queryUserInfo,
  fileUpload,
  queryPCA,
  getProviderListToWeb,
  queryPersonByPolicy,
  getFileType,
  preAuthpatch,
  getProviderList,
  getIncrementRight
};